'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getLangLocale = require('./getLangLocale');

var _getLangLocale2 = _interopRequireDefault(_getLangLocale);

var _TitleFormatters = require('./TitleFormatters');

var _TitleFormatters2 = _interopRequireDefault(_TitleFormatters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CJK_HIRAGANA_REGEX = new RegExp(/[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]|[\u3040-\u309F]|[\u3005]|[\u3031-\u3032]/);

var KATAKANA_REGEX = new RegExp(/[\u30A0-\u30FF]/);

var KATAKANA_SEPARATOR = '・';

// Formats a first and last name depending on the character set.

exports.default = function (_ref, options) {
  var name = _ref.name,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      email = _ref.email,
      titleType = _ref.titleType;

  var first = firstName && firstName.trim();
  var last = lastName && lastName.trim();
  var fullName = name && name.trim();

  var formattedName = void 0;
  if (!first && !last) {
    formattedName = fullName || email || '';
  } else if (first && !last) {
    formattedName = first;
  } else if (!first && last) {
    formattedName = last;
  } else if (CJK_HIRAGANA_REGEX.test(last) && (CJK_HIRAGANA_REGEX.test(first) || KATAKANA_REGEX.test(first))) {
    formattedName = last + ' ' + first;
  } else if (KATAKANA_REGEX.test(first) && KATAKANA_REGEX.test(last)) {
    formattedName = '' + first + KATAKANA_SEPARATOR + last;
  } else {
    formattedName = first + ' ' + last;
  }

  if (titleType) {
    var lang = options && options.locale || (0, _getLangLocale2.default)();
    var titleFormatter = _TitleFormatters2.default[lang] && _TitleFormatters2.default[lang][titleType];
    if (titleFormatter) {
      formattedName = titleFormatter(formattedName);
    }
  }

  return formattedName;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/js/utils/formatName.js
// module id = 66
// module chunks = 0